import { component as defineComponent } from 'flightjs';

export default defineComponent(function () {
    this.attributes({
        'counter': '[data-count]',
        'countLabel': '[data-button-count]'
    });

    this.after('initialize', function () {
        this.on(document, 'uiBrowseFiltersUpdated', this.toggleDisplay);
        this.on(document, 'dataBrowseCategoryCountLoaded', this.updateCount);
    });

    this.isInterestedCategory = function (categoryKey) {
        return ('|' + this.$node.attr('data-category-filter') + '|').indexOf('|' + categoryKey + '|') >= 0;
    };

    this.updateCount = function (e, counts) {
        this.select('counter').each(
            function (i) {
                var value = $(this).data('value');
                var count = counts[value] || 0;
                $(this).text('(' + count + ')');
                $(this).data('count', count);
            }
        );
    };

    this.toggleDisplay = function (e, data) {
        var newCount = null;
        if (data.category) {
            if (this.isInterestedCategory('all') || this.isInterestedCategory(data.category)) {
                this.$node.removeAttr('data-hidden');

                this.select('counter').each(
                    function (i) {
                        if ($(this).data('value') === data.category) {
                            newCount = $(this).data('count');
                        }
                    }
                );

                if (newCount) {
                    this.select('countLabel').text('(' + newCount + ')');
                    this.select('countLabel').data('value', data.category);
                }

            } else {
                this.$node.attr('data-hidden', true);
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/category-filter.js